import { Network } from '@capacitor/network';
import { isNative } from './env';

export async function getNetworkStatus() {
    if (!isNative) {
        return { connected: navigator.onLine, connectionType: navigator.onLine ? 'unknown' : 'none' };
    }
    return Network.getStatus();
}

export function addNetworkListener(handler) {
    if (!isNative) {
        const onlineHandler = () => handler({ connected: true, connectionType: 'unknown' });
        const offlineHandler = () => handler({ connected: false, connectionType: 'none' });
        window.addEventListener('online', onlineHandler);
        window.addEventListener('offline', offlineHandler);
        return () => {
            window.removeEventListener('online', onlineHandler);
            window.removeEventListener('offline', offlineHandler);
        };
    }
    const subscription = Network.addListener('networkStatusChange', handler);
    return () => {
        subscription.then((s) => s.remove?.()).catch(() => {});
    };
}
